import { Redirect } from 'react-router-dom';

const TestMeaningRedirect = () => <Redirect to="/tests/sens-valeurs" />;

export default TestMeaningRedirect;
